import { render } from "./FormVin.vue?vue&type=template&id=7c2468a4&ts=true"
import script from "./FormVin.vue?vue&type=script&lang=ts"
export * from "./FormVin.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__